import { apiKeys } from "../../../../../../constants";
import refreshTokens from "./refreshTokens";
export default {
  [apiKeys.REFRESH_TOKENS]: refreshTokens
};